module.exports = __webpack_public_path__ + "static/media/card.1e1cd537.svg";